module.exports = __webpack_public_path__ + "img/Differentiation-GBM_10X_WTA.a3238013.png";